// extracted by mini-css-extract-plugin
export default {"breed_pill":"BreedPills_breed_pill__XKaw-","spin":"BreedPills_spin__HPCe-"};